"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineImageInput = void 0;
var react_1 = __importDefault(require("react"));
var ImageInputContext_1 = require("../../ImageInputContext");
var Placeholder_1 = __importDefault(require("../Placeholder"));
/**
 * this component will expand in its complexity with time
 */
var InlineImageInput = function (_a) {
    var _b, _c;
    var _d = (0, ImageInputContext_1.useImageInputContext)(), isLoading = _d.isLoading, value = _d.value;
    return isLoading ? (react_1.default.createElement(Placeholder_1.default, { aspectRatio: "4/1" })) : value && ((_b = value[0]) === null || _b === void 0 ? void 0 : _b.publicUrl) ? (react_1.default.createElement("div", null,
        react_1.default.createElement("img", { src: (_c = value[0]) === null || _c === void 0 ? void 0 : _c.publicUrl, style: { width: '100%', height: 'auto' } }))) : null;
};
exports.InlineImageInput = InlineImageInput;
